import { getCookie } from '@util/cookies';

/**
 * isLocalDev() is checks whether or not the DevScriptsEnabled cookie is true
 * DevScriptsEnabled is true of the development branch is set to localhost
 */
export const isLocalDev = () =>
  !!getCookie('DevScriptsEnabled') || !!getCookie('FrontEndBranchName');

const getServer = () => {
  const { hostname, port } = window.top.location;
  return `${hostname}${port ? `:${port}` : ''}`;
};

export const getOneClickURL = ({
  username,
  organizationId,
  customerId,
  branchName,
  pathName
}) => {
  const domain = window.top.location.hostname.split('.');

  return `https://crm.${
    domain?.includes('dev') ? 'dev.' : ''
  }schoolobjects.com/crm/Impersonate.aspx?user=${username}${
    customerId ? `&customer-id=${customerId}` : ''
  }&org=${organizationId}&server=${getServer()}&fe-branch=${encodeURIComponent(
    branchName || ''
  )}&ReturnUrl=${encodeURIComponent(
    (pathName || window.top.location.pathname) + window.top.location.search
  )}`;
};
